import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import SAlert from "components/Alert"
import useSearch from "hooks/useSearch"
import ProvinceOutListComponent from "components/ProvinceOut/list"
import {
  deleteManyProvinceOut,
  deleteProvinceOut,
  exportProvinceOut,
  getProvinceOutProvinces,
  getProvinceOuts,
} from "store/province-out/province-out-action"
import {
  getProvinceIps,
  getProvinceItemCategories,
  getProvinceProjects,
  getProvinceProvinces,
} from "store/province-dashboard/province-dashboard-action"
import ProvinceOutDetailModal from "components/ProvinceOut/Details"
import { getProvinceInProjects } from "store/province-in/province-in-action"

const ProvinceOutList = () => {
  document.title = "Distributions"

  const dispatch = useDispatch()
  const { data, error, loading, exportStatus } = useSelector(state => ({
    data: state.provinceOut.data,
    error: state.provinceOut.error,
    loading: state.provinceOut.loading,
    exportStatus: state.provinceOut.exportStatus,
  }))
  const permissions = useSelector(state => state.auth.permissions)
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  const handleDeleteFunc = data => {
    if (proOut) {
      dispatch(deleteProvinceOut(proOut.id))
    }
    setDeleteModal(false)
  }

  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(deleteManyProvinceOut(ids))
    } else {
      SAlert({ text: "no distribution selected", status: "info" })
    }
  }
  const onClickDelete = data => {
    setProOut(data)
    setDeleteModal(true)
  }

  const onPageClick = link => {
    dispatch(
      getProvinceOuts(link.url, pageNumber, according, search, advnacedSearch)
    )
  }

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  useSearch(
    getProvinceOuts(undefined, undefined, undefined, search, advnacedSearch),
    search
  )

  useEffect(() => {
    dispatch(
      getProvinceOuts(undefined, pageNumber, according, search, advnacedSearch)
    )
  }, [pageNumber, according])

  useEffect(() => {
    dispatch(getProvinceItemCategories())
    dispatch(getProvinceOutProvinces())
    dispatch(getProvinceIps())
    dispatch(getProvinceInProjects())
  }, [])

  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getProvinceOuts(undefined, undefined, undefined, search, data))
  }

  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  const onExportBtnClick = () => {
    dispatch(exportProvinceOut(advnacedSearch))
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <ProvinceOutDetailModal
        data={proOut}
        open={detailModal}
        setOpen={setDetailModal}
      />
      <Breadcrumbs title={"Province"} breadcrumbItem={"Distributions"} />
      <ProvinceOutListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        permissions={permissions}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default ProvinceOutList
